import styled from 'styled-components'
import { fontType, toRem } from '../../styles/functions'

export const CopyCodeContainer = styled.div`
	width: 100%;
	min-height: 53px;
	border: 2px solid ${({ theme }) => theme.COLORS.BLACK};
	border-radius: 5px;
	display: flex;
	align-items: center;
	padding: 18px;

	cursor: pointer;

	:active {
		opacity: 0.8;
	}
`

export const CopyCode = styled.span`
	color: ${({ theme }) => theme.COLORS.LIGHT_GRAFFITI};
	text-align: left;
	font-size: ${toRem(16)};
	${fontType(2)}
	width: 100%;
	overflow: hidden;
`

export const CopyIcon = styled.img``
